import type { TimeFrame } from 'components/AnimatedTimelineControl';
import { formatDate, SHORT_MONTH_DAY_12HOUR_FORMAT } from 'shared/dates';

/** Range relative to now, in minutes (negative offsets are in the past) */
export type TimeRange = {
  startOffsetMin: number;
  endOffsetMin: number;
  stepMin: number;
};

const MINUTE_MS = 60 * 1000;

const toFrame = (ms: number): TimeFrame => {
  const timestamp = new Date(ms);
  return {
    timestamp,
    label: formatDate(timestamp, SHORT_MONTH_DAY_12HOUR_FORMAT),
  };
};

/** Frames every `stepMin` back from the range end, oldest first. */
export const buildTimeRangeFrames = (
  { startOffsetMin, endOffsetMin, stepMin }: TimeRange,
  nowMs: number,
): TimeFrame[] => {
  if (stepMin <= 0 || endOffsetMin < startOffsetMin) return [];

  const endMs = nowMs + endOffsetMin * MINUTE_MS;
  const stepMs = stepMin * MINUTE_MS;
  const count = Math.floor((endOffsetMin - startOffsetMin) / stepMin) + 1;
  return Array.from({ length: count }, (_, i) =>
    toFrame(endMs - (count - 1 - i) * stepMs),
  );
};
